<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-menu"></i> 表格</el-breadcrumb-item>
        <el-breadcrumb-item>基础表格</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="handle-box">
      <!-- <el-button type="primary" icon="delete" class="handle-del mr10" @click="delAll">批量删除</el-button> -->
      <el-select v-model="select_cate" placeholder="筛选后缀" class="handle-select mr10">
        <el-option key="1" label="txt" value="txt"></el-option>
        <el-option key="2" label="" value=""></el-option>
      </el-select>
      <el-input v-model="select_word" placeholder="筛选关键词" class="handle-input mr10"></el-input>
      <el-button type="primary" icon="search" @click="search">搜索</el-button>
    </div>

    <el-dialog
        title="文件内容"
        :visible.sync="dialogVisible"
        width="30%">
      <el-input type="textarea" autosize v-model="fileToBeUpdatedContent"></el-input>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">更 新</el-button>
          </span>
    </el-dialog>

    <el-dialog
        title="文件内容"
        :visible.sync="dialogReadVisible"
        width="30%">
      <el-input type="textarea" autosize v-model="fileToBeReadContent" :disabled="true"></el-input>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleDialogReadConfirm">确 定</el-button>
          </span>
    </el-dialog>


    <div>
      <el-link v-for="result in total_paths" :key="result.text"
               :underline="false" @click="getData(result.path)"
               type="primary">{{ result.text }}
      </el-link>
    </div>

    <el-table :data="data" border style="width: 100%" ref="multipleTable">
      <el-table-column label="名称" width="270">
        <template slot-scope="scope1">
          <el-link v-if="scope1.row.type=='DIRECTORY'" target="_blank"
                   class="buttonText" @click="getData(scope1.row.fileName)" type="primary"
                   :underline="false">{{ scope1.row.fileName }}
          </el-link>
          <span v-else>{{ scope1.row.fileName }}          </span>

        </template>
      </el-table-column>


      <el-table-column prop="fileLength" label="大小">
      </el-table-column>

      <el-table-column prop="owner" label="用户">
      </el-table-column>
      <el-table-column prop="group" label="组">
      </el-table-column>
      <el-table-column prop="permission" label="权限">
      </el-table-column>
      <el-table-column prop="modificationTime" label="修改时间">
      </el-table-column>
      <el-table-column label="操作" width="270">
        <template slot-scope="scope">
          <el-button size="small"
                     @click="handleRead( scope.row)">查看
          </el-button>
          <el-button size="small"
                     @click="handleUpdate( scope.row)">更新
          </el-button>
          <el-button size="small"
                     @click="handleDownload( scope.row)">下载
          </el-button>
          <el-button size="small" type="danger"
                     @click="handleDelete( scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pagination">
        <el-pagination
                @current-change ="handleCurrentChange"
                layout="prev, pager, next"
                :total="1000">
        </el-pagination>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment-timezone'

moment.tz("Asia/Shanghai");
export default {
  name: "BaseTable",
  data() {
    return {
      tableData: [],
      total_paths: [],
      cur_page: 1,
      multipleSelection: [],
      select_cate: '',
      select_word: '',
      is_search: false,
      dialogVisible: false,
      dialogReadVisible: false,
      fileToBeUpdatedContent: '',
      fileToBeUpdatedName: '',
      fileToBeReadContent: ''
    }
  },
  created() {
    this.getData('/');
  },
  computed: {
    data() {
      const self = this;
      return self.tableData.filter(function (d) {

        if (d.fileName.indexOf(self.select_cate) > -1 &&
            (d.fileName.indexOf(self.select_word) > -1)
        ) {
          return d;
        }
      })
    }
  },
  methods: {

    perm_to_text(octal) {
      var result = ""
      var value_letters = {4: "r", 2: "w", 1: "x"}
      for (var i = 0; i < octal.length; i++) {
        var permission = parseInt(octal.charAt(i))
        // console.logdd()
        for (var value in value_letters) {
          var letter = value_letters[value]
          if (permission >= value) {
            result += letter
            permission -= value;
          } else
            result += "-"
        }
      }
      return result
    },
    handleCurrentChange(val) {
      this.cur_page = val;
      this.getData();
    },
    getData(path) {
      this.total_paths = []
      var total_paths_tmp = path.split("/")
      for (var i = 0; i < total_paths_tmp.length; i++) {
        var tmp = ""
        for (var j = 0; j < i; j++) {
          tmp += total_paths_tmp[j] + "/"
        }
        this.total_paths.push({"text": total_paths_tmp[i]+"/", "path": tmp})
      }


      this.$http.get(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + path + '?op=LISTSTATUS&user.name=root').then(response => {
        var pathList = response.data;
        if (pathList != null && pathList.FileStatuses != null && pathList.FileStatuses.FileStatus != null) {
          pathList = pathList.FileStatuses.FileStatus;

          this.tableData = []
          for (var i = 0; i < pathList.length; i++) {
            var temp = pathList[i];
            // console.log(temp);
            if (temp.type == 'FILE')
              this.tableData.push({
                'fileName': path + temp.pathSuffix,
                'fileLength': temp.length,
                'modificationTime': moment(temp.modificationTime).format('YYYY/DD/MM hh:mm:ss'),
                'fileReplication': temp.replication,
                'type': temp.type,
                'owner': temp.owner,
                'group': temp.group,
                'permission': this.perm_to_text(temp.permission),
              });
            if (temp.type == 'DIRECTORY') {
              // var subPath = path + temp.pathSuffix + '/';
              // this.getData(subPath);
              this.tableData.push({
                'fileName': path + temp.pathSuffix + "/",
                'fileLength': temp.length,
                'modificationTime': moment(temp.modificationTime).format('YYYY/DD/MM hh:mm:ss'),
                'fileReplication': temp.replication,
                'type': temp.type,
                'owner': temp.owner,
                'group': temp.group,
                'permission': this.perm_to_text(temp.permission),
              });
            }

          }
        }


      }, response => {
        console.log("error");
        console.log(response);
      });
    },
    search() {
      this.is_search = true;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    handleRead(row) {
      this.$http.get(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + row.fileName + '?op=OPEN&user.name=root').then(response => {

        console.log(row.fileName + " is read success");

        this.dialogReadVisible = true;
        this.fileToBeReadContent = response.bodyText;

      }, response => {

        console.log("error");
        console.log(response);
      });


    },
    handleUpdate(row) {
      this.$http.get(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + row.fileName + '?op=OPEN&user.name=root').then(response => {

        console.log(row.fileName + " is read success");

        this.dialogVisible = true;
        this.fileToBeUpdatedContent = response.bodyText;
        this.fileToBeUpdatedName = row.fileName;

      }, response => {

        console.log("error");
        console.log(response);
      });


    },
    handleDelete(row) {
      this.$message.error('删除吗？');
      this.$http.delete(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + row.fileName + '?op=DELETE&user.name=root').then(response => {

        console.log(row.fileName + " is deleted success" + response);
        //刷新视图
        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i] == row) {
            this.tableData.splice(i, 1);
            break;
          }
        }

      }, response => {

        console.log("error");
        console.log(response);
      });

    },
    handleDownload(row) {
      // var index1 = row.fileName.lastIndexOf(".");
      // var index2 = row.fileName.length;
      // var suffix = row.fileName.substring(index1 + 1, index2);
      // if (!(suffix == 'txt' || suffix == 'json' || suffix == 'csv' || suffix == 'html')) {
      //   this.$message.info('请直接从HDFS下载文件' + (row.fileName));
      //   return;
      // }

      this.$message.info('下载文件' + (row.fileName));
      this.$http.get(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + row.fileName + '?op=OPEN&user.name=root').then(response => {

        console.log(row.fileName + " is read success");
        console.log(response);
        this.downloadFile(row.fileName, response.bodyText)
      }, response => {

        console.log("error");
        console.log(response);
      });
    },
    downloadFile(fileName, content) {

      var aLink = document.createElement('a');
      var blob = new Blob([content], {
        type: 'image/png'
      });
      // var evt = new Event('click');
      aLink.download = fileName;
      aLink.href = URL.createObjectURL(blob);
      aLink.click();
      URL.revokeObjectURL(blob);

    },
    handleDialogReadConfirm() {
      this.dialogReadVisible = false;
    },
    handleDialogConfirm() {

      this.$http.put(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + this.fileToBeUpdatedName + '?op=CREATE&user.name=root', this.fileToBeUpdatedContent,
          {headers: {'content-type': 'application/octet-stream'}}).then(response => {
        console.log(response)
        this.$message.info('文件' + (this.fileToBeUpdatedName) + '更新成功');

        this.$http.get(process.env.VUE_APP_HDFS_HOST + '/webhdfs/v1' + this.fileToBeUpdatedName + '?op=LISTSTATUS&user.name=root').then(response => {

          var fileToBeUpdatedLength = response.body.FileStatuses.FileStatus[0].length;

          //刷新视图
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].fileName == this.fileToBeUpdatedName) {
              this.tableData[i].fileLength = fileToBeUpdatedLength;
              break;
            }
          }

          this.dialogVisible = false;

        }, response => {
          console.log(response);
          console.log("error");
        });


      }, response => {

        console.log("error");
        console.log(response);
      });

    }
  }
}
</script>

<style scoped>
.handle-box {
  margin-bottom: 20px;
}

.handle-select {
  width: 120px;
}

.handle-input {
  width: 300px;
  display: inline-block;
}
</style>
